import { Button, Container, List, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { START_CLICKED } from "./constants";
import { ScreenProps } from "./types";

const RequestLetterLanding = ({
  state: { accountInfo },
  dispatch,
}: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="letter" width="112" />
    <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
      Need a letter?
    </Text>
    <Container bg="secondary.lightBlue.t25" padding="4">
      <Container bg="white" padding="6">
        {accountInfo.isClosed ? (
          <Stack gap="6">
            <Text>
              <strong>
                You can easily request a letter from us, but before you do here
                are some things to know:
              </strong>
            </Text>
            <List>
              <List.Item>
                You can request a letter to confirm account closure. The letter
                will be emailed to you within 5 business days.
              </List.Item>
              <List.Item>
                If you would like a letter posted to your house please give us a
                call.
              </List.Item>
            </List>
          </Stack>
        ) : (
          <Stack gap="6">
            <Text>
              <strong>
                You can easily request a letter from us to confirm activity on
                your account, but before you do here are some things to know:
              </strong>
            </Text>
            <List>
              <List.Item>
                The letter will be emailed to you within 5 business days.
              </List.Item>
              <List.Item>
                The letter will be based on the most recent information. For
                example: The current account balance or last credit limit
                decrease.
              </List.Item>
              <List.Item>
                If you would like a letter posted to your house please give us a
                call.
              </List.Item>
            </List>
          </Stack>
        )}
      </Container>
    </Container>
    <Button
      width="160"
      onClick={() => {
        dispatch({
          type: START_CLICKED,
        });
      }}
    >
      Start
    </Button>
  </Stack>
);

export { RequestLetterLanding };
